import { merge, omit } from 'lodash';

import { AppData } from '../state/AppData';
import { apify } from './apify';

export interface IPayload {
  authenticityToken: string;
  orderItem: {
    bookId: number;
    customization: {
      avatars: Array<{
        features: Record<string, string>;
        id: number;
      }>;
      childPhoto: {
        id: number;
        path: string;
      } | null;
      dedicationPhoto: {
        id: number;
        path: string;
      } | null;
      language: string;
      textVariables: Record<string, string>;
    };
    extraProducts: Array<number>;
    wrap: number | null;
  };
}

export function bookPayloadFormater(state: AppData): IPayload {
  const avatarParams = state.avatars.map(({ params }) => params);
  const moreMagicParams = state.moreMagic.filter(({ isCompleted }) => isCompleted).map(({ params }) => params);
  const wrap = state.wraps.find(({ isSelected }) => isSelected);

  const payload = {
    authenticityToken: state.token,
    orderItem: {
      bookId: state.bookId,
      customization: {
        avatars: state.avatars.map((avatar) => {
          const features = omit(
            avatar.params,
            avatar.fields.map(({ uid }) => uid),
          );

          return {
            features: { ...avatar.defaultPreview, ...features },
            id: avatar.id,
          };
        }),
        childPhoto: state.childImage ? { id: state.childImage.id, path: state.childImage.path } : null,
        dedicationPhoto: state.dedicationImage
          ? { id: state.dedicationImage.id, path: state.dedicationImage.path }
          : null,
        language: state.currentLanguage,
        textVariables: merge({}, ...avatarParams, ...moreMagicParams),
      },
      extraProducts: state.extraProducts.filter(({ isSelected }) => isSelected).map(({ id }) => id),
      wrap: wrap ? wrap.id : null,
    },
  };

  // Format dedication as HTML instead of text
  if (payload.orderItem.customization.textVariables.dedication) {
    // tslint:disable-next-line: max-line-length
    payload.orderItem.customization.textVariables.dedication = payload.orderItem.customization.textVariables.dedication.replace(
      /(?:\r\n|\r|\n)/g,
      '<br>',
    );
  }
  return apify(payload) as IPayload;
}
